import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import { Checkbox } from '@els/els-react--checkbox';

import './CheckboxFilter.scss';

export default function CheckboxFilter({ filter, onChange, className, disableControls, ...rest }) {
  const title = filter.get('title');
  const selected = filter.get('selected');

  return (
    <Checkbox
      data-e2e={rest['data-e2e'] || 'checkbox-filter'}
      className={`${className} checkbox-filter`}
      checked={selected}
      onChange={onChange}
      disabled={disableControls}
      label={title}
    />
  );
}

CheckboxFilter.propTypes = {
  filter: PropTypes.instanceOf(Map).isRequired,
  onChange: PropTypes.func.isRequired,
};
